import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";


const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_CONTACT = `${BASE_URL}getpagedata/contact.php`;

const ContactForm = () => {

const [form,setForm] = useState({
    name:"",
    email:"",
    phone:"",
    message:""
});

const handleSubmit = async(e)=>{
    e.preventDefault();

    try{

        const res = await axios.post(API_CONTACT, form);

        if(!res.data.success){
            Swal.fire("Error",res.data.message,"error");
            return;
        }

        Swal.fire("Success","Message sent successfully","success");

        setForm({
            name:"",
            email:"",
            phone:"",
            message:""
        });

    }catch(err){
        Swal.fire("Error","Server error occurred","error");
    }
};

return(

<form onSubmit={handleSubmit}>

<div className="row">
<div className="col-md-6 mb-3">
<input
type="text"
className="form-control"
placeholder="Your Name"
value={form.name}
onChange={(e)=>setForm({...form,name:e.target.value})}
required
/>
</div>

<div className="col-md-6 mb-3">
<input
type="email"
className="form-control"
placeholder="Your Email"
value={form.email}
onChange={(e)=>setForm({...form,email:e.target.value})}
required
/>
</div>
</div>

<div className="mb-3">
<input
type="text"
className="form-control"
placeholder="Phone"
value={form.phone}
onChange={(e)=>setForm({...form,phone:e.target.value})}
required
/>
</div>

<div className="mb-3">
<textarea
className="form-control"
rows="5"
placeholder="Your Message"
value={form.message}
onChange={(e)=>setForm({...form,message:e.target.value})}
/>
</div>

<button className="btn btn-primary px-4 py-2">Send Message</button>

</form>

);
};

export default ContactForm;